import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

class OrderFormComponent extends HTMLElement {
  private root: any = null;

  static get observedAttributes() {
    return ["data-id"];
  }

  connectedCallback() {
    // Create root once when component is connected
    this.root = createRoot(this);
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  disconnectedCallback() {
    // Use unmount instead of unmountComponentAtNode
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }

  render() {
    const id = this.getAttribute("data-id") || "";
    console.log("WebComponent id:", id);
    if (this.root) {
      this.root.render(<App id={id} />);
    }
  }
}

customElements.define("order-form", OrderFormComponent);
